import { defineMessages } from 'react-intl';

export default defineMessages({
  voidedReturnSectionTitle: {
    defaultMessage: 'Voided Return',
    description: 'Title for a section that shows voided return shipment',
    id: 'ImzYV9',
  },
  voidedReturnSectionAriaLabel: {
    defaultMessage: 'Voided Return section',
    description: 'Aria label for the voided return shipment section',
    id: 'lxUF4n',
  },
});
